import React from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "./redux"
import { clearFocusedNote } from "~/Planner/reducer2/noteSlice"

type Props = {
  notes: ReadonlyArray<{ readonly id: number }> | null
  type: "person" | "project"
  openSidePanel: (noteId: number) => void
}

const useViewNoteInSidePanel = (props: Props) => {
  const { notes, type, openSidePanel } = props

  const dispatch = useDispatch()
  const { focusedNoteId, noteType } = useAppSelector(
    (state) => state.plannerV2.note,
  )

  React.useEffect(() => {
    if (focusedNoteId && noteType === type && notes != null) {
      if (notes.find((note) => note.id === focusedNoteId)) {
        openSidePanel(focusedNoteId)
      }

      dispatch(clearFocusedNote())
    }
  }, [focusedNoteId, noteType, type, openSidePanel, dispatch, notes])
}

export { useViewNoteInSidePanel }
